/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Language_Code_PlaceholderInputs */

const en_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eng`)
};

const fr_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eng`)
};

const de_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eng`)
};

const it_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inglese`)
};

const ru_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`англ.`)
};

const es_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eng`)
};

const zh_cn2_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eng`)
};

const ja_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英語`)
};

const hi_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंग्लैंड`)
};

const pt_pt2_image_export_language_code_placeholder = /** @type {(inputs: Image_Export_Language_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eng`)
};

/**
* | output |
* | --- |
* | "eng" |
*
* @param {Image_Export_Language_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_language_code_placeholder = /** @type {((inputs?: Image_Export_Language_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Language_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_language_code_placeholder(inputs)
	if (locale === "de") return de_image_export_language_code_placeholder(inputs)
	if (locale === "it") return it_image_export_language_code_placeholder(inputs)
	if (locale === "ru") return ru_image_export_language_code_placeholder(inputs)
	if (locale === "es") return es_image_export_language_code_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_language_code_placeholder(inputs)
	if (locale === "ja") return ja_image_export_language_code_placeholder(inputs)
	if (locale === "hi") return hi_image_export_language_code_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_language_code_placeholder(inputs)
	return en_image_export_language_code_placeholder(inputs)
});